export const UPDATE_CREW_DETAILS = "UPDATE_CREW_DETAILS";
export const UPDATE_CREW_VALIDATIONS = "UPDATE_CREW_VALIDATIONS";
export const CREATE_CREW_ROW = "CREATE_CREW_ROW";
export const DELETE_CREW_ROW = "DELETE_CREW_ROW";
export const UPDATE_CREW_ACTIVITIES = "UPDATE_CREW_ACTIVITIES";